/**令牌-数据响应字段 */
export const TOKEN_RESPONSE_FIELD = 'access_token';

/**令牌-请求头标识前缀 */
export const TOKEN_KEY_PREFIX = 'Bearer ';

/**令牌-请求头标识 */
export const TOKEN_KEY = 'Authorization';

/**令牌-存放Cookie标识 */
export const TOKEN_COOKIE = 'AuthEl';
